import React from "react";
import "./Footer.css";
import logo from "../../assets/images/logo-trimmed.png";
import { Socials } from "../../components";
import { navigateHandler } from "../../helpers";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Footer = () => {
  return (
    <motion.footer
      initial={{ y: 50, opacity: 0 }}
      transition={{ delay: 1, duration: 2 }}
      whileInView={{ opacity: 1, y: 0 }}
    >
      <div className="connect">
        <div className="text">Let's Connect!</div>
        <Socials />
      </div>
      <div className="info">
        <img className="logo-ft" src={logo} alt="Michael Quarcoo" />

        <div className="copyright">
          &copy; {new Date().getFullYear()} Michael Quarcoo. All rights reserved
        </div>
      </div>
      <div className="aside-links">
        <div className="text">Quick Links</div>
        <div className="links">
          <Link onClick={navigateHandler} to="/">
            Home
          </Link>
          <Link onClick={navigateHandler} to="/#about">
            About
          </Link>
          <Link onClick={navigateHandler} to="/#interests">
            Interests
          </Link>
          <Link onClick={navigateHandler} to="/#skills">
            Skills
          </Link>
          <Link onClick={navigateHandler} to="/#contact">
            Contact
          </Link>
          <Link onClick={navigateHandler} to="/#portfolio">
            Portfolio
          </Link>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
